/**
 * Stable CSS class names for E2E — MP client translations.
 */
export const MPCT = {
    page: 'mp-client-translations-page',
    loadingGate: 'mp-client-translations-page__loading-gate',
    loadingSpinnerWrap: 'mp-client-translations-page__loading-spinner',

    titleSection: 'mp-client-translations-page__title-section',
    pageTitle: 'mp-client-translations-page__title',

    actionsSection: 'mp-client-translations-page__actions-section',
    actionsInner: 'mp-client-translations-page__actions-inner',
    cultureDropdownWrap: 'mp-client-translations-page__culture-dropdown-wrap',
    addButtonWrap: 'mp-client-translations-page__add-button-wrap',
    inputButtonAddTranslation: 'mp-client-translations-page-input--button-add-translation',

    tabsWrap: 'mp-client-translations-page__tabs-wrap',
    tabsRoot: 'mp-client-translations-page__tabs',
    tabTranslationList: 'mp-client-translations-page-input--tab-translation-list',
    tabBulkUpload: 'mp-client-translations-page-input--tab-bulk-upload',

    listTabSearchWrap: 'mp-client-translations-list-tab__search-wrap',
    inputTextSearchKey: 'mp-client-translations-list-tab-input--text-search-key',
    listTabGridWrap: 'mp-client-translations-list-tab__grid-wrap',

    datagridEditCell: 'mp-client-translations-datagrid-actions-cell-edit',
    inputButtonRowEdit: 'mp-client-translations-datagrid-input--button-row-edit',
    datagridDeleteCell: 'mp-client-translations-datagrid-actions-cell-delete',
    inputButtonRowDelete: 'mp-client-translations-datagrid-input--button-row-delete',

    bulkTabRoot: 'mp-client-translations-bulk-tab',
    bulkTabTitle: 'mp-client-translations-bulk-tab__title',
    bulkTabSubtitle: 'mp-client-translations-bulk-tab__subtitle',
    bulkTabWarningAlert: 'mp-client-translations-bulk-tab__warning-alert',
    bulkTabUploadWrap: 'mp-client-translations-bulk-tab__upload-wrap',
    bulkTabSummarySection: 'mp-client-translations-bulk-tab__summary-section',
    bulkTabSummaryActive: 'mp-client-translations-bulk-tab__summary-active',
    bulkTabSummaryTitle: 'mp-client-translations-bulk-tab__summary-title',
    bulkTabStatusRow: 'mp-client-translations-bulk-tab__status-row',
    bulkTabSummaryPlaceholder: 'mp-client-translations-bulk-tab__summary-placeholder',
    bulkTabResultsSection: 'mp-client-translations-bulk-tab__results-section',
    bulkTabResultsToolbar: 'mp-client-translations-bulk-tab__results-toolbar',
    bulkTabResultsTitle: 'mp-client-translations-bulk-tab__results-title',
    bulkTabResultsDownloadWrap: 'mp-client-translations-bulk-tab__results-download-wrap',
    bulkTabResultsGridWrap: 'mp-client-translations-bulk-tab__results-grid-wrap',
} as const;

export const mpctCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
